@import "../../../variables.scss";

$work-card-background: #ebebeb;

.workCard {
  background-color: $work-card-background;
  border-radius: 4px;

  &__inner {
    margin-bottom: 8px;
  }

  &__title {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 441px) {
      width: 130px;
    }
  }

  &__subtitle {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 441px) {
      width: 130px;
    }
  }

  &__duration {
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.23px;
    color: $color-grey;
    text-align: right;
  }

  &__description {
    line-height: 16px;
    letter-spacing: 0.26px;
    font-size: 14px;
    width: 332px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @media (max-width: 441px) {
      width: 256px;
    }
  }
}

.workHistoryForm {
  z-index: 1200;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  &__container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @media (max-width: 991px) {
        padding: 0;
      }
  }

  &__dateContainer {
    flex-wrap: nowrap;
    width: 450px;
    @media (max-width: 576px) {
      flex-wrap: wrap;
      width: unset;
    }
  }

  &__month {
    width: 112px;
  }

  &__year {
    width: 70px;
  }

  &__present {
    margin-top: 15px;
    @media (max-width: 576px) {
      visibility: hidden;
      height: 75px;
    }
  }

  &__description {
    resize: none;
    height: 120px;
    @media (max-width: 576px) {
      height: 40px !important;
    }
  }

  &__position {
    width: 370px;
    @media (max-width: 576px) {
      width: 260px;
    }
  }

  &__buttonContainer {
    @media (max-width: 576px) {
      margin-top: 20px;
      position: relative;
      left: 15px;
    }
  }
}

.cvInfo {
  &__upload {
    background-color: $color-orange;
    border-color: $color-orange;
    &:hover {
      background-color: $color-orange;
      border-color: $color-orange;
    }
  }

  &__invalidFormat {
    color: red;
  }

  &_button__container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    a:hover {
      text-decoration: none;
    }

    button {
      width: 140px;
      &:hover {
        text-decoration: none;
      }
    }
  }

  &__secondary {
    color: $color-grey;
    background-color: white;
    text-decoration: none;
    &:hover {
      color: $color-grey;
      background-color: white;
      text-decoration: none;
    }
  }

  &__imageTitle {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  &__form {
    padding-left: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 991px) {
      padding: 0;
    }
  }

  &__link {
    display: flex;
    justify-content: center;

    @media (max-width: 441px) {
      font-size: 0.85rem;
    }
  }

  &__imageText {
    position: relative;
    z-index: 5;
    color: $color-white;
    text-align: center;

    h3 {
      font-size: 1.4rem;
    }

    @media (max-width: 991px) {
      text-align: left;
      p {
        font-size: 1.3rem;
      }
      h3 {
        font-size: 1.2rem;
      }
    }
  }

  &__filename {
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;

    @media (max-width: 441px) {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      width: 280px;
    }
  }

  &__imageText {
    position: relative;
    z-index: 5;
    color: $color-white;
    text-align: center;

    h3 {
      font-size: 1.4rem;
    }

    @media (max-width: 991px) {
      text-align: left;
      p {
        font-size: 1.3rem;
      }
      h3 {
        font-size: 1.2rem;
      }
    }
  }

  &__image {
    position: absolute;
    z-index: 5;
    left: 180px;
    bottom: -371px;
  }

  &__text {
    width: 50%;
    @media (max-width: 991px) {
      width: 100%;
    }
  }

  &__imageBackground {
    position: relative;
    @media (max-width: 991px) {
      margin-bottom: 30px;
      padding: 0;
    }
  }

  &__imageBackground:after {
    content: "";
    width: 2032px;
    height: 1296px;
    background-color: $color-background-blue;
    position: absolute;
    left: -278%;
    top: -541px;
    border-radius: 50%;

    @media (max-width: 1200px) {
      left: -350%;
    }
    @media (max-width: 991px) {
      left: -44%;
      top: -75%;
      width: 200%;
      height: 193%;
    }
  }
}
